import React from 'react';
import PropTypes from 'prop-types';

function MastercardIcon({ className, monochrome }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="36"
      viewBox="0 0 48 36"
      className={className}
    >
      <g fill="none">
        <path fill={monochrome ? '#444' : '#FF5F00'} d="M19.3 10.2H29v15.6h-9.6z" />
        <path
          fill={monochrome ? '#000' : '#EB001B'}
          d="M20.3 18a10 10 0 0 1 3.8-7.8 10 10 0 1 0 0 15.6 10 10 0 0 1-3.8-7.8z"
        />
        <path
          fill={monochrome ? '#888' : '#F79E1B'}
          d="M40.2 18a10 10 0 0 1-16 7.8 10 10 0 0 0 0-15.6 10 10 0 0 1 16 7.8z"
        />
      </g>
    </svg>
  );
}

MastercardIcon.propTypes = {
  className: PropTypes.string,
  monochrome: PropTypes.bool,
};

export default MastercardIcon;
